<script>
import SurveyRequestAnswerDeleteModal from 'App/Models/SurveyRequestAnswer/SurveyRequestAnswerDeleteModal.vue'

export default {
    props: ['initialSurveyRequest', 'wrapperClass'],

    data() {
        return {
            surveyRequest: this.initialSurveyRequest,
        }
    },

    methods: {
        formatLongAnswer(answer){
          return answer.replace(/\n/g,'<br/>');
        },
        getFormattedResponse(answer) {
            if (/\d{4}\-\d{2}\-\d{2}/.test(answer)) {
                return moment(answer, 'YYYY-MM-DD')
                    .locale(moment_locale)
                    .format('LL');
            }

            return this.formatLongAnswer(new String(answer).toString());
        },
    },

    components: {
        SurveyRequestAnswerDeleteModal
    }
};
</script>

<template>
    <div v-if="surveyRequest && surveyRequest.answers && surveyRequest.answers.length > 0">
        <div v-for="(answer, index) in surveyRequest.answers" :key="answer.id" :class="wrapperClass" class="survey-answer">
            <div class="flex items-center gap-1">
                <div class="font-bold">
                    {{ index + 1 }}. {{ answer.question }}
                </div>

                <survey-request-answer-delete-modal v-if="$can('edit-surveys')" :survey-request-answer="answer"/>
            </div>

            <div
                v-if="answer.survey_field?.description"
                class="text-muted mb-5"
            >
                {{ answer.survey_field.description }}
            </div>

            <div v-if="answer.answer_choices && answer.answer_choices.length">
                <div
                    v-for="choice in answer.answer_choices"
                    :key="choice"
                    :class="{ 'text-muted': !answer.answer.includes(choice) }"

                >
                    <i
                        class="zmdi"
                        :class="{
                            'zmdi-check-square': answer.answer.includes(choice),
                            'zmdi-square-o': !answer.answer.includes(choice),
                        }"
                    ></i>
                    {{ getFormattedResponse(choice) }}
                </div>
            </div>

            <div v-else>
                <div v-for="answer in answer.answer" :key="answer.id">
                    <p class="m-b-0"  v-sanitize-html="getFormattedResponse(answer)"></p>
                </div>
            </div>
        </div>
    </div>
</template>

<style scoped>
.delete-survey-answer {
    padding: 5px 10px;
    color: #333;
}
.delete-survey-answer:hover {
    background-color: #f4f8fb;
}
</style>
